import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from "./auth/auth.component";
import { RootComponent } from "./root/root.component";
import { AdminGuardService } from "./@guards/admin.guard";
import { MainComponent } from "./main/main.component";
import { NewsComponent } from './forms/news/news.component';

const routes: Routes = [
    { path: 'auth', component: AuthComponent },
    {
        path: '', component: RootComponent, canActivate: [ AdminGuardService ],
        children: [
            { path: 'form/news', component: NewsComponent },
            // {
            //     path: 'form/contacts', component: ContactsComponent,
            //     children: [
            //         { path: ':id', component: MessagesComponent },
            //     ]
            // },
            { path: 'table/:table', component: MainComponent },
        ]
    },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {
}
